import { Blockchain } from "@rarible/api-client"
import { lightlinkPhoenix } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const lightlinkConfig: StaticEthereumBlockchainConfig = {
  name: "LightLink",
  icon: "/images/blockchains/lightlink.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://lightlink-api.rarible.org",
  chainId: 1890,
  blockchain: Blockchain.LIGHTLINK,
  chainName: "LightLink",
  exchange: {
    v2: "0x5faf16A85028BE138A7178B222DeC98092FEEF97",
    wrapper: "0x0B7Acd053BC236fc95537e2aDD37C22968b48C1b",
  },
  blockExplorers: [
    {
      url: "https://phoenix.lightlink.io",
      icon: "/images/scanner.svg",
      adress: "https://phoenix.lightlink.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "lightlink-node",
  transferProxies: {
    nft: "0xF65eF65a95821A16E02973b1C2200FA58898e3c0",
    erc721Lazy: "0xce4bf732f53A76C463aE8822be858017b02779c8",
    erc20: "0x248B46BEB66b3078D771a9E7E5a0a0216d0d07ba",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("LIGHTLINK:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ethereum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("LIGHTLINK:0x7ebef2a4b1b09381ec5b9df8c5c6f2dbeca59c73"),
    symbol: "WETH",
    name: "Wrapped Ethereum",
    decimals: 18,
  },
  addFundsLink: "https://lightlink.io/bridge",
  hasStabilityProtocol: true,
  viem: lightlinkPhoenix,
}

export const getLightlinkConfig = (): StaticEthereumBlockchainConfig =>
  lightlinkConfig
